import _ from 'underscore';
import Mn from 'backbone.marionette';


export const FilterView = Mn.LayoutView.extend({
  attributes: {
    id: 'filter'
  },

  className: 'filter',

  template: require('./template.html'),

  ui: {
    filter: '.filter-box'
  },

  events: {
    'change @ui.filter': 'searchCollection',
    'keyup @ui.filter': 'searchCollection',
    'keydown @ui.filter': 'removeReturn',
    'submit': 'searchCollection'
  },

  searchCollection: _.debounce(function () {
    const filterVal = this.ui.filter.val();
    this.model.set({
      query: filterVal
    });
    if(this.getOption('empty_on_filter')){
      this.collection.reset();
    }

    this.model.search(this.collection);
  }, 400),

  removeReturn(e) {
    return e.keyCode !== 13;
  }
});



// WEBPACK FOOTER //
// ./forms/filter/view.js